import { gql } from '@/__generated__/gql';

export const CREATE_CONTACT_MUTATION = gql(`
  mutation EnterContactInfoModalPageCreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id
    }
  }
`);

export const UPDATE_CONTACT_MUTATION = gql(`
  mutation EnterContactInfoModalPageUpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      id
    }
  }
`);

export const DELETE_CONTACT_MUTATION = gql(`
  mutation EnterContactInfoModalPageDeleteContact($id: ID!) {
    deleteContact(id: $id)
  }
`);
